/**
 * Created by dmarthak on 06/02/18.
 */
define(function (require, exports, module) {
    'use strict';

    // @ngInject
    exports.TranslateService = function (lpCoreI18n) {
        function translate(key) {
            return lpCoreI18n.instant(key) || key;
        }
        return {
            translate: translate
        };
    };

});



//////////////////
// WEBPACK FOOTER
// ./scripts/translate-service.js
// module id = 6
// module chunks = 0